import { render } from "./AttachmentModal.vue?vue&type=template&id=d8265e3a"
import script from "./AttachmentModal.vue?vue&type=script&lang=js"
export * from "./AttachmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__